import { render, staticRenderFns } from "./SysLanguageConfigurationList.vue?vue&type=template&id=8220459a&scoped=true&"
import script from "./SysLanguageConfigurationList.vue?vue&type=script&lang=js&"
export * from "./SysLanguageConfigurationList.vue?vue&type=script&lang=js&"
import style0 from "./SysLanguageConfigurationList.vue?vue&type=style&index=0&id=8220459a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8220459a",
  null
  
)

export default component.exports